import {Pipe, PipeTransform} from '@angular/core';
import {ISpot} from '../../interfaces/date';

@Pipe({
  name: 'getDateFromSystem'
})
export class GetDateFromSystemPipe implements PipeTransform {

  transform(spot: ISpot, ...args: unknown[]): Date {
    const date = new Date();
    const hour = Math.trunc(spot.startSystem / 60);
    const minutes = (spot.startSystem % 60);
    date.setHours(hour);
    date.setMinutes(minutes);
    return date;
  }

}
